import { FormControl, FormHelperText } from '@mui/material'
import { Field } from 'formik'
import * as React from 'react'
import { DatePicker } from './FormikDatePicker'

export interface IDatePickerFieldProps {
  name: string
  label: string
  inputId: string
  required?: boolean
  fullWidth?: boolean
  variant?: string
  clearable?: boolean
  className?: string
  shrink?: boolean
  errorMessage?: string
  onDateChange?: (date: Date | undefined) => void
  disabled?: boolean
  style?: React.CSSProperties
}

export default class DatePickerField extends React.Component<IDatePickerFieldProps> {
  constructor(props: IDatePickerFieldProps) {
    super(props)
  }

  public render() {
    const {
      name,
      label,
      inputId,
      required = false,
      fullWidth = false,
      variant,
      clearable,
      className,
      errorMessage,
      onDateChange,
      disabled = false,
      style,
    } = this.props
    return (
      <FormControl
        fullWidth={fullWidth}
        required={required}
        className={className}
        error={errorMessage !== undefined}
      >
        <Field
          format="MM/DD/YYYY"
          label={label}
          name={name}
          disabled={disabled}
          inputProps={{ id: inputId, style: style }}
          InputLabelProps={{ shrink: this.shouldShrink() }}
          component={DatePicker}
          variant={variant}
          clearable={clearable}
          required={required}
          onDateChange={onDateChange}
          height={70}
        />
        {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
      </FormControl>
    )
  }

  public shouldShrink() {
    return this.props.shrink !== undefined ? this.props.shrink : true
  }
}
